import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../../Assets/img/logo_2.png'
import { FacebookOutlined, InstagramOutlined, LinkedinOutlined, WhatsAppOutlined } from '@ant-design/icons';


const Footer = () => {
  const navigate = useNavigate()
  const [showPopup, setShowPopup] = useState(false)

  const handleContactUsClick = (e) => {
    e.preventDefault()
    navigate('/contact-us')
  }

  const navItemsPart1 = [
    { label: 'Home', path: '/' },
    { label: 'Events', path: '/events/uupcoming-events' },
    { label: 'About Us', path: '/about/whoweare' },
    { label: 'Career with Us', path: '/career-with-us' },
    { label: 'Membership', path: '/membership/plans' }
  ]

  const navItemsPart2 = [
    { label: 'Board Members', path: '/our-board' },
    { label: 'Functional Committee', path: '/our-committee' },
    { label: 'Privacy Policy', path: '/privacy-policy' },
    { label: 'Terms and Conditions', path: '/terms-conditions' },
    { label: 'Refund Policy', path: '/refund' }
  ]

  const handleLinkClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const togglePopup = () => {
    setShowPopup(!showPopup)
  }

  
return (
  <footer className='bg-gray-900 text-white pt-8 pb-4 relative'>
    <div className='container mx-auto flex flex-wrap justify-between items-start gap-8 relative'>
      
      {/* Logo Section */}
      <div className="flex flex-col items-center px-5 sm:px-0">
      <h4 className='text-base sm:text-xl font-bold mb-3 sm:mb-4 pl-1'>
          <img src={logo} alt='APCCI Logo' style={{ maxWidth: '100px' }} />
        </h4>
        <p className="text-sm sm:text-base text-center font-bold px-2" style={{ maxWidth: '300px' }}>
          Association of Professional Career Counselors of India
        </p>
        <p className="text-xs sm:text-sm text-center mt-4 sm:mt-6">
          Empowering Career Counsellors Nationwide
        </p>
        <div style={{ fontSize: "24px", display: "flex", gap: "12px", marginTop: '10px' }} className="sm:text-[32px] lg:text-[40px]">
          <a href="https://www.instagram.com/apcci_india/" target="_blank" rel="noopener noreferrer">
            <InstagramOutlined
              style={{
                background: "linear-gradient(45deg, #f9ce34, #ee2a7b, #6228d7)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            />
          </a>
          <a href="https://www.linkedin.com/company/apcciin" target="_blank" rel="noopener noreferrer">
            <LinkedinOutlined style={{ color: "#0A66C2" }} />
          </a>
          <a href="https://wa.me/9625751947" target="_blank" rel="noopener noreferrer">
            <WhatsAppOutlined style={{ color: "#25D366" }} />
          </a>
        </div>
      </div>

      {/* Quick Links Section */}
      <div className='flex flex-col'>
        <h4 className='text-base sm:text-xl font-bold mb-3 sm:mb-4'>Quick Links</h4>
        <ul className='space-y-2'>
          {navItemsPart1.map((item, index) => (
            <li key={index}>
              <Link
                to={item.path}
                className='text-sm sm:text-base hover:text-blue-400 transition-colors duration-200'
                onClick={handleLinkClick}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* More Links Section */}
      <div className='flex flex-col'>
        <h4 className='text-base sm:text-xl font-bold mb-3 sm:mb-4'>More Links</h4>
        <ul className='space-y-2'>
          {navItemsPart2.map((item, index) => (
            <li key={index}>
              <Link
                to={item.path}
                className='text-sm sm:text-base hover:text-blue-400 transition-colors duration-200'
                onClick={handleLinkClick}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Contact Us Section */}
      <div className='flex flex-col' style={{ maxWidth: "300px" }}>
        <h4 className='text-base sm:text-xl font-bold mb-3 sm:mb-4'>Contact Us</h4>
        
        <p className='text-sm sm:text-base mb-2'>
         <b>Registered Address:</b> 134-B, X-Block, New Roshanpura, Najafgarh, South West Delhi, New Delhi- 110043
        </p>
        <p className='text-sm sm:text-base mb-2'>
          <b>Email:</b>{' '}
          <a
            href='mailto:connect@apcci.in'
            className='text-white-600 underline'
          >
            connect@apcci.in
          </a>
        </p>
        <div className="text-sm sm:text-base">
          <span>
            <b>WhatsApp:</b><a href="https://wa.me/9625751947" target="_blank" rel="noopener noreferrer">
            +91-9625751947
            </a>
          </span>
          <br />
          <span className="pl-11 sm:pl-12 ml-7 md:ml-9">
          {/* <a href="https://wa.me/918373939097" className="text-white text-decoration-none"> +91-8373939097</a> */}
          </span>
        </div>       
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <button
          onClick={togglePopup}
          className="text-white px-3 py-2 sm:px-4 sm:py-2 rounded-lg shadow-lg hover:bg-blue-500 hover:scale-105 text-sm sm:text-base"
          style={{ background: "linear-gradient(180deg, #0078BF 0%, #244183 100%)" }}
        >
          Subscribe to Our Newsletter
        </button>
      </div>
    </div>    

    <div className='text-center mt-6 sm:mt-8 border-t border-gray-700 pt-3 sm:pt-4 text-xs sm:text-sm'>
      © 2025 APCCI. All Rights Reserved.
    </div>

    {/* Popup */}
    {showPopup && (
      <div
        className="fixed inset-0 bg-white bg-opacity-25 flex justify-center items-center z-50"
        onClick={togglePopup}
      >
        <div
          className="bg-[#0d73b9] p-2 rounded-lg shadow-lg relative"
          style={{ width: '90%', maxWidth: '650px' }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={togglePopup}
            className="absolute top-2 right-3 text-gray-700 text-2xl"
          >
            &times;
          </button>

          <h2 className="text-2xl text-white text-center font-bold mb-4">APCCI Newsletter Subscription</h2>

          <div
            className="rounded align-center"
            style={{ width: '100%', height: '400px', overflow: 'hidden' }}
          >
            <iframe
              src="https://pay.apcci.in/widget/form/cHFOwBoO3pc8O9CUDLwT"
              style={{ width: "100%", height: "100%", border: "none", borderRadius: "4px" }}
              id="popup-cHFOwBoO3pc8O9CUDLwT"
              data-layout="{'id':'POPUP'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="APCCI Newsletter subscription"
              data-height="340"
              data-layout-iframe-id="popup-cHFOwBoO3pc8O9CUDLwT"
              data-form-id="cHFOwBoO3pc8O9CUDLwT"
              title="APCCI Newsletter subscription"
            ></iframe>
            <script src="https://pay.apcci.in/js/form_embed.js"></script>
          </div>
        </div>
      </div>
    )}
  </footer>
)
}

export default Footer